import CheckCircleIcon from "@atlaskit/icon/core/check-circle";
import CheckCircleOutlineIcon from "@atlaskit/icon/core/status-success";
import WarningIcon from "@atlaskit/icon/core/status-warning";
import Spinner from "@atlaskit/spinner";
import { token } from "@atlaskit/tokens";

import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { FormattedMessageProps } from "../../messages";

export const IsValidOrLoading = ({
    isValidating,
    siteNameValue,
    validationMessage
}: {
    isValidating: boolean;
    siteNameValue: string;
    validationMessage?: FormattedMessageProps;
}) => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    if (siteNameValue === "") {
        return null;
    }
    if (isValidating) {
        return <Spinner size="small" testId="spinner" />;
    }
    if (validationMessage) {
        return (
            <WarningIcon label="warning" color={token("color.icon.danger")} />
        );
    }
    return team26VisualUpdates ? (
        <CheckCircleIcon
            label="success"
            color={token("color.icon.accent.lime")}
        />
    ) : (
        <CheckCircleOutlineIcon
            label="success"
            color={token("color.icon.success")}
        />
    );
};
